module.exports = __webpack_public_path__ + "media/assets/icons/file-text2-233173de92cea6f908ea1d60e94b96b3.svg";